import { usePages } from "@shapeable/ui";
import { isInvitedContribution } from "../types";
import { transformPage } from "../utils/transforms";

export const useInvitedContributions = () => (usePages().filter(isInvitedContribution).map(transformPage));
